import React, { useState } from 'react'
import logout from "../../../assets/img/rides/logout.svg"
import "./modelCss.scss";
import { Spinner } from 'reactstrap';

export default function LogoutModel({ isOpen, close, logutUser, ...props }) {
    const [loading, setLoading] = useState(false);

    const handleLogout = async () => {
        try {
            setLoading(true);
            await logutUser();
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            {isOpen && (
                <div className="model_block">
                    <div className='row' style={{ justifyContent: "center", alignItems: "center", height: "100%" }}>
                        <div className='col-4'>
                            <div className='model_content_block'>
                                <div className='model_content_block_overlay'>
                                    <img style={{ height: "50px" }} src={logout} alt="logout" />
                                    <div className='model_text' style={{ padding: "1.5rem 0",fontSize:"16px",fontWeight:"500" }}>Are your sure you want to logout?</div>
                                    <div className='button_block' style={{ fontSize: "20px", marginTop: "0.5rem" }}>
                                        <div style={{ padding: "10px 40px",fontSize:"14px", color: "black", border: "1px solid gray", pointerEvents: loading ? 'none' : 'auto', opacity: loading ? 0.6 : 1 }}
                                            onClick={(e) => {
                                                if (!loading) close(e)
                                            }}
                                        >Cancel</div>
                                        <div style={{ padding: "10px 40px", fontSize:"14px", pointerEvents: loading ? 'none' : 'auto', opacity: loading ? 0.6 : 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }} 
                                             onClick={handleLogout}
                                        >
                                            {loading && <Spinner size="sm" style={{ marginRight: '6px', color: 'white' }} />}
                                            Logout
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
